import { render, staticRenderFns } from "./CITHome.vue?vue&type=template&id=2a5e87b4&scoped=true"
import script from "./CITHome.vue?vue&type=script&lang=js"
export * from "./CITHome.vue?vue&type=script&lang=js"
import style0 from "./CITHome.vue?vue&type=style&index=0&id=2a5e87b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e87b4",
  null
  
)

export default component.exports